import { useState, useEffect, useMemo } from 'react';
import Axios from "axios";
import { AddBenchCandidatesProfile_BulkImport, SubmitLinkedInUrls, GenerateContent, search, getcallback, AddLeads_BulkImport, AddHotList_BulkImport } from '../apiconstants/constants.js';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import nodataimg from "../assets/images/Nodata.jpg";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner.js';
import ConsultantLayout from '../commonlayouts/consultantlayout.js';
import * as pdfjsLib from "pdfjs-dist";
import Swal from 'sweetalert2';
import { Modal, Button, Form } from "react-bootstrap";
import axios from 'axios';
import { useCountry } from "../contexts/countrycodecontext.js";
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const plainText = doc.body.textContent || "";
  return plainText;
};

function substring_str(str) {
  if ((str === null) || (str === ' ' || str === undefined))
    return "";
  else
    str = str.toString();
  return str.substring(0, 100) + "...";
}

const ViewMatchedLinkedinContacts = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const jobDescription = location.state?.jobDescription ? location.state?.jobDescription : localStorage.getItem('jobDescription') 
  const keyskills = location.state?.keyskills ? location.state?.keyskills : localStorage.getItem('keyskills') 
const locationvalue =
  location.state?.location ||
  localStorage.getItem('location') ||
  "United States";

  const experience = location.state?.experience ?  location.state?.experience :  localStorage.getItem('experience') ;
  const jobPlainText = stripHtml(jobDescription).toLowerCase() ;
  

  const [offset, setOffset] = useState(0);
  const [data, setData] = useState([]);
  const [perPage] = useState(25);
  const [pageCount, setPageCount] = useState(0);
  const [candidateData, setCandidateData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const [startDate, setStartDate] = useState(""); // Start date state
  const [endDate, setEndDate] = useState(""); // End date state
  const [showIcon, setShowIcon] = useState('list');
  const [viewType, setViewType] = useState('list'); // 'grid' or 'list'
  const token = localStorage.getItem('jwtToken');
  const jobRoleID = localStorage.getItem('jobRoleID');
   const [selectedCards, setSelectedCards] = useState(
     JSON.parse(localStorage.getItem('selectedCandidates')) || []
   );
  const [extractedJDSkills, setExtractedJDSkills] = useState("");
  const [showLinkedinModal, setShowLinkedinModal] = useState(false);
  const [modalJobSkills, setModalJobSkills] = useState("");
const [modalLocation, setModalLocation] = useState("United States");
const [modalExperience, setModalExperience] = useState("");
const [searchType, setSearchType] = useState('skills');
const [modalSkillsError, setModalSkillsError] = useState("");
const [isAllSelected, setIsAllSelected] = useState(false);
const [visibleCandidates, setVisibleCandidates] = useState([]);
const [fetchedLinkedInCandidates, setFetchedLinkedInCandidates] = useState([]);
const [showImportModal, setShowImportModal] = useState(false);
const [selectedDestination, setSelectedDestination] = useState(""); 


  const Guid = localStorage.getItem("guid");
    const {selectedCountry}=useCountry();
    console.log(selectedCountry)
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage * perPage);
  };
  const handleViewToggle = (type) => {
    setViewType(type);
    setShowIcon(type)
  };
  const handleSearch = (e) => {
  setSearchTerm(e.target.value.toLowerCase());
};

useEffect(() => {
  setOffset(0); // when search term changes
}, [searchTerm]);


useEffect(() => {
  const fromEmailPage = localStorage.getItem('fromSendEmailPage');

  if (fromEmailPage === 'true') {
    const cached = localStorage.getItem('cachedCandidateData');
    const selectedEmails = JSON.parse(localStorage.getItem('SelectedCandidateEmails') || '[]');
    if (cached) {
      const data = JSON.parse(cached);
      setCandidateData(data);
      const selected = data.filter(candidate => selectedEmails.includes(candidate.email));
      setSelectedCards(selected);
    }
    localStorage.removeItem('fromSendEmailPage');
    return;
  }

  // ✅ new: call fetchLinkedInCandidates with URLs passed from state or localStorage
  const urlsFromState = location.state?.linkedinUrls || JSON.parse(localStorage.getItem("linkedinUrls") || "[]");
  const jobRoleIdFromState = location.state?.jobRoleId || localStorage.getItem("jobRoleId");

  if (urlsFromState.length > 0) {
    const urlsPayload = {
      skills: urlsFromState.join(", "), // trick the system by treating urls as "skills"
      experience: "",
      location: "",
      userGuid: Guid
    };

    localStorage.setItem("didRunAnalyze", "true"); // ✅ so it doesn't re-run
    fetchLinkedInCandidates(urlsPayload);
  }

}, []);


const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const normalized = (str) =>
  str?.toLowerCase().replace(/\s+/g, " ").trim();

const fetchLinkedInCandidates = async (payload) => {
  try {
      localStorage.removeItem('cachedCandidateData'); // clear old cache
        setIsLoading(true);
    console.log("88",payload)
      // ✅ Handle LinkedIn URL search
      const urls = payload.skills
        .split(",")
        .map(url => url.trim())
        .filter(url => url.startsWith("http"));

// setCandidateData([
//   {
//     name: "John Doe",
//     email: "john.doe1@example.com",
//     phone: "+1234567890",
//     skills: "JavaScript, React.js, Node.js",
//     location: "New York, NY, USA",
//     title: "Frontend Developer at TechCorp",
//     linkedInUrl: "https://www.linkedin.com/in/john-doe-12345",
//     profileSummary: "Experienced frontend engineer with a passion for UI/UX."
//   },
//   {
//     name: "Jane Smith",
//     email: "jane.smith1@example.com",
//     phone: "+1987654321",
//     skills: "Python, Django, REST APIs",
//     location: "San Francisco, CA, USA",
//     title: "Backend Developer at CodeWorks",
//     linkedInUrl: "https://www.linkedin.com/in/jane-smith-67890",
//     profileSummary: "Backend engineer building scalable web services."
//   },
//   {
//     name: "Rahul Mehta",
//     email: "rahul.mehta@example.com",
//     phone: "+919999999999",
//     skills: "Java, Spring Boot, Microservices",
//     location: "Hyderabad, Telangana, India",
//     title: "Software Engineer at Infosys",
//     linkedInUrl: "https://www.linkedin.com/in/rahul-mehta-98765",
//     profileSummary: "Java developer with 4 years of experience in microservices architecture."
//   },
//   {
//     name: "Sara Wilson",
//     email: "sara.wilson@example.com",
//     phone: "+447700900123",
//     skills: "AWS, DevOps, Kubernetes",
//     location: "London, UK",
//     title: "DevOps Engineer at CloudWorks",
//     linkedInUrl: "https://www.linkedin.com/in/sara-wilson-45678",
//     profileSummary: "Certified DevOps engineer with hands-on cloud infrastructure expertise."
//   }
// ]
// )
// setFetchedLinkedInCandidates([
//   {
//     name: "John Doe",
//     email: "john.doe1@example.com",
//     phone: "+1234567890",
//     skills: "JavaScript, React.js, Node.js",
//     location: "New York, NY, USA",
//     title: "Frontend Developer at TechCorp",
//     linkedInUrl: "https://www.linkedin.com/in/john-doe-12345",
//     profileSummary: "Experienced frontend engineer with a passion for UI/UX.",
//     countryID:selectedCountry
//   },
//   {
//     name: "Jane Smith",
//     email: "jane.smith1@example.com",
//     phone: "+1987654321",
//     skills: "Python, Django, REST APIs",
//     location: "San Francisco, CA, USA",
//     title: "Backend Developer at CodeWorks",
//     linkedInUrl: "https://www.linkedin.com/in/jane-smith-67890",
//     profileSummary: "Backend engineer building scalable web services.",
//         countryID:selectedCountry

//   },
//   {
//     name: "Rahul Mehta",
//     email: "rahul.mehta@example.com",
//     phone: "+919999999999",
//     skills: "Java, Spring Boot, Microservices",
//     location: "Hyderabad, Telangana, India",
//     title: "Software Engineer at Infosys",
//     linkedInUrl: "https://www.linkedin.com/in/rahul-mehta-98765",
//     profileSummary: "Java developer with 4 years of experience in microservices architecture.",
//         countryID:selectedCountry
//   },
//   {
//     name: "Sara Wilson",
//     email: "sara.wilson@example.com",
//     phone: "+447700900123",
//     skills: "AWS, DevOps, Kubernetes",
//     location: "London, UK",
//     title: "DevOps Engineer at CloudWorks",
//     linkedInUrl: "https://www.linkedin.com/in/sara-wilson-45678",
//     profileSummary: "Certified DevOps engineer with hands-on cloud infrastructure expertise.",
//         countryID:selectedCountry

//   },
//     {
//     name: "Sara Wilson1",
//     email: "sara.wilson1@example.com",
//     phone: "+447700900123",
//     skills: "AWS, DevOps, Kubernetes",
//     location: "London, UK",
//     title: "DevOps Engineer at CloudWorks",
//     linkedInUrl: "https://www.linkedin.com/in/sara-wilson-45678",
//     profileSummary: "Certified DevOps engineer with hands-on cloud infrastructure expertise.",
//         countryID:selectedCountry

//   },
//     {
//     name: "Sara Wilson2",
//     email: "sara.wilson2@example.com",
//     phone: "+447700900123",
//     skills: "AWS, DevOps, Kubernetes",
//     location: "London, UK",
//     title: "DevOps Engineer at CloudWorks",
//     linkedInUrl: "https://www.linkedin.com/in/sara-wilson-45678",
//     profileSummary: "Certified DevOps engineer with hands-on cloud infrastructure expertise.",
//         countryID:selectedCountry

//   }
// ]
// )
      const response = await axios.post(
        SubmitLinkedInUrls.APIURL,
        { linkedInUrls: urls,userGuid: guid },
        { headers: { "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
         } }
      );

      const message = response.data?.message || "";
  
      if (message.includes("Request submitted successfully")) {
        console.log("✔ LinkedIn Request submitted, calling getcallback API...");
        await wait(50000); // ⏳ Wait for SignalHire to send data to callback
        const callbackResponse = await axios.get(`${getcallback.APIURL}?userGuid=${guid}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (callbackResponse.data && Array.isArray(callbackResponse.data)) {
                   const cleanedCandidates = callbackResponse.data?.map((item) => {
  const candidate = item.candidate;

  const email = candidate.contacts?.find(c => c.type === "email")?.value || null;
  const phone = candidate.contacts?.find(c => c.type === "phone")?.value || null; // optional, if available later
  const linkedInUrl = candidate.social?.find(s => s.type === "li")?.link || item.item;
const currentExperience = candidate.experience?.find(exp => exp.current) || candidate.experience?.[0] || {};
const companyName = currentExperience.company || "";
const websiteURL = currentExperience.website || "";

  return {
    name: candidate.fullName,
    email: email,
    phone: phone,
    skills: candidate.skills?.join(", ") || "",
    location: candidate.locations?.[0]?.name || "",
    title: candidate.headLine || "",
    linkedInUrl: linkedInUrl,
    profileSummary: candidate.summary || "",
    companyName: companyName,
    websiteURL: websiteURL // ✅ include website
  };
});

   setCandidateData(cleanedCandidates);
   setFetchedLinkedInCandidates(cleanedCandidates); // ✅ for saving
        } else {
          Swal.fire("No Data", "No candidates received from callback.", "info");
           setCandidateData([]);
        }
      } else {
        Swal.fire("Error", "LinkedIn URL submission failed or invalid response.", "error");
        setCandidateData([]);
      }
  
    
  setIsLoading(false);
 } catch (err) {
    setIsLoading(false);
    console.error("Error fetching LinkedIn candidates", err);
  }
};
const handleFetchCallbackData = async () => {
  try {
    setIsLoading(true);
    const response = await axios.get(`${getcallback.APIURL}?userGuid=${guid}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (response.data && Array.isArray(response.data)) {
      const cleanedCandidates = response.data
        .filter(item => item.candidate) // ✅ prevent undefined access
        .map((item) => {
          const candidate = item.candidate;

          const email = candidate.contacts?.find(c => c.type === "email")?.value || null;
          const phone = candidate.contacts?.find(c => c.type === "phone")?.value || null;
          const linkedInUrl = candidate.social?.find(s => s.type === "li")?.link || item.item;

          return {
            name: candidate.fullName || "",
            email,
            phone,
            skills: candidate.skills?.join(", ") || "",
            location: candidate.locations?.[0]?.name || "",
            title: candidate.headLine || "",
            linkedInUrl,
            profileSummary: candidate.summary || ""
          };
        });

// const locationValue = localStorage.getItem("location") || "";
// console.log("E282:", locationValue);


// const locationTokens = normalized(locationValue).split(/[,\s]+/); // Split by comma or space

// const filteredCandidates = locationValue
//   ? cleanedCandidates.filter(candidate => {
//       const candidateLoc = normalized(candidate.location);
//       return locationTokens.some(token => candidateLoc.includes(token));
//     })
//   : cleanedCandidates;

// setCandidateData(filteredCandidates);
       setCandidateData(cleanedCandidates);
    } else {
      Swal.fire("No Data", "No candidates received from callback.", "info");
    }
  } catch (error) {
    console.error("Error calling getcallback API:", error);
    Swal.fire("Error", "Failed to fetch candidate data.", "error");
  } finally {
    setIsLoading(false);
  }
};
 const guid = localStorage.getItem("guid");
const handleSaveFetchedCandidates = async () => {
  const jobRole = localStorage.getItem("jobRoleId");
    let Guid="";
   
    const employerGuid = localStorage.getItem("employerGuid")
    const email = localStorage.getItem("email")
    const roleID = localStorage.getItem("roleID")
     const jobRoleId = localStorage.getItem("jobRoleId")
    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= guid
    }

 if (!selectedDestination) {
    Swal.fire("Error", "Please select a save destination.", "warning");
    return;
  }
if (selectedCards.length === 0) {
  Swal.fire("Error", "Please select at least one candidate.", "warning");
  return;
}

const selectedCandidates = selectedCards;


  try {
    let payload = [];
    let apiURL = "";

    if (selectedDestination === "candidatePool") {
      payload = selectedCandidates.map(item => ({
        userGuid: Guid,
        fullName: item.name,
        email: item.email,
        mobileNumber: item.phone,
        dob: "2000-01-01",
        gender: "Male",
        address: item.location,
        jobRole,
        maritalStatus: "married",
        technicalSkill: item.skills,
        experience: "",
        preferLocation: selectedCountry,
        workMode: "Hybrid",
        profileSummery: item.profileSummary,
        billRate: "",
        payRate: "",
        workAuthorizationandValidity: "",
        employerName: "",
        ssn: "",
        passportNo: "",
        tworefrencesfromrecentproject: "",
        linkedInUrl: item.linkedInUrl,
        certifications: "",
        createdBy: email,
        countryID: selectedCountry
      }));
      apiURL = AddBenchCandidatesProfile_BulkImport.APIURL;
    }

    if (selectedDestination === "recruiter" || selectedDestination === "benchSales") {
      payload = selectedCandidates.map(item => ({
        name: item.name,
        emailId: item.email,
        phone: item.phone,
        company: item.companyName,
        website: item.websiteURL || "",
        description: item.profileSummary,
        country: selectedCountry,
        type: selectedDestination === "recruiter" ? "Recruiter" : "Bench Sales",
        tierType: "Tier 2",
        createdBy: email,
        countryID: Number(selectedCountry),
        userGuid:guid,
      }));
      apiURL = AddHotList_BulkImport.APIURL;
    }

    if (selectedDestination === "leads") {
      payload = selectedCandidates.map(item => ({
        fullName: item.name,
        email: item.email,
        phoneNumber: item.phone,
        dateOfBirth: "2000-01-01",
        linkdinUrl: item.linkedInUrl,
        websiteURL: item.websiteURL || "",
        companyName: item.companyName,
        domain: item.profileSummary,
        createdBy: email,
        userGuid:Guid,
        countryID: selectedCountry
      }));
      apiURL = AddLeads_BulkImport.APIURL;
    }

    const response = await axios.post(apiURL, payload, {
      headers: { 
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
       }
    });

    // 🌟 Show Import Summary based on response structure
//     const details = response.data.details || response.data.candidates || response.data.records;

//   //   const insertedList = details.filter(item => item.isInserted || item.statusMessage === "Inserted"||
//   // item.status === "Inserted" );
//   //   const duplicateList = details.filter(item => !item.isInserted || item.statusMessage === "Duplicate or Already Exists" ||
//   // item.status === "Duplicate or Already Exists");
// const insertedList = details.filter(item => 
//   (item.isInserted === true) || 
//   item.statusMessage === "Inserted" || 
//   item.status === "Inserted"
// );

// const duplicateList = details.filter(item => 
//   (item.isInserted === false) || 
//   item.statusMessage === "Duplicate or Already Exists" || 
//   item.status === "Duplicate or Already Exists"
// );
//     Swal.fire({
//       title: 'Import Summary',
//       icon: insertedList.length > 0 ? 'success' : 'warning',
//       html: `
//         <div style="text-align:left">
//           ✅ <strong>Successfully Inserted:</strong> ${insertedList.length}<br/>
//           ❌ <strong>Duplicates:</strong> ${duplicateList.length}<br/><br/>
//           ${insertedList.length > 0 ? '<strong>Inserted Records:</strong><br/>' + insertedList.map(i => `• ${i.email || i.emailId} (${i.statusMessage || 'Inserted'})`).join('<br/>') + '<br/><br/>' : ''}
//           ${duplicateList.length > 0 ? '<strong>Duplicate Records:</strong><br/>' + duplicateList.map(d => `• ${d.email || d.emailId} (${d.statusMessage || d.status})`).join('<br/>') : ''}
//         </div>
//       `,
//       confirmButtonText: 'OK'
//     });
const details = response.data.details || response.data.candidates || response.data.records || [];

// Normalize so all APIs have a "status" we can check
const normalizedDetails = details.map(item => ({
  email: item.email || item.emailId || '',
  status: item.status || item.statusMessage || (item.isInserted === true ? 'Inserted' : 'Duplicate or Already Exists')
}));

// Now filter cleanly
const insertedList = normalizedDetails.filter(item => item.status === 'Inserted');
const duplicateList = normalizedDetails.filter(item => item.status === 'Duplicate or Already Exists');

Swal.fire({
  title: 'Import Summary',
  icon: insertedList.length > 0 ? 'success' : 'warning',
  html: `
    <div style="text-align:left">
      ✅ <strong>Successfully Inserted:</strong> ${insertedList.length}<br/>
      ❌ <strong>Duplicates:</strong> ${duplicateList.length}<br/><br/>
      ${insertedList.length > 0 ? '<strong>Inserted Records:</strong><br/>' + insertedList.map(i => `• ${i.email} (${i.status})`).join('<br/>') + '<br/><br/>' : ''}
      ${duplicateList.length > 0 ? '<strong>Duplicate Records:</strong><br/>' + duplicateList.map(d => `• ${d.email} (${d.status})`).join('<br/>') : ''}
    </div>
  `,
  confirmButtonText: 'OK'
});

    setShowImportModal(false);
  }catch (err) {
    console.error("Error saving:", err);
    Swal.fire("Error", "Failed to save candidates.", "error");
  }
};


const filteredCandidates = useMemo(() => {
  const lowerSearchTerm = searchTerm?.toLowerCase()?.trim();
  if (!lowerSearchTerm) return candidateData;

  // Determine AND/OR based on input keywords
  let searchTerms = [];
  let isAndSearch = false;

  if (lowerSearchTerm.includes(' + ') || lowerSearchTerm.includes(' and ')) {
    searchTerms = lowerSearchTerm.split(/\s*\+\s*|\s+and\s+/);
    isAndSearch = true; // Match ALL
  } else if (lowerSearchTerm.includes(' or ')) {
    searchTerms = lowerSearchTerm.split(/\s+or\s+/);
    isAndSearch = false; // Match ANY
  } else {
    searchTerms = [lowerSearchTerm];
    isAndSearch = false;
  }

  searchTerms = searchTerms.map(term => term.trim());

  return candidateData.filter((candidate) => {
    const skills = candidate.skills?.toLowerCase() || "";
    const location = candidate.location?.toLowerCase() || "";

    const matchesTerm = (term) =>
      skills.includes(term) || location.includes(term);

    return isAndSearch
      ? searchTerms.every(matchesTerm)
      : searchTerms.some(matchesTerm);
  });
}, [candidateData, searchTerm]);



const handleSelectAll = () => {
  const allFiltered = filteredCandidates.filter(
    (c) => c.email != null || c.phone != null
  );

  const allSelected = allFiltered.every((candidate) =>
    selectedCards.some(
      (selected) => getUniqueId(candidate) === getUniqueId(selected)
    )
  );

  if (allSelected) {
    // ❌ Unselect all filtered candidates
    const updated = selectedCards.filter(
      (selected) =>
        !allFiltered.some(
          (candidate) =>
            getUniqueId(candidate) === getUniqueId(selected)
        )
    );
    setSelectedCards(updated);
  } else {
    // ✅ Select all filtered candidates
    const newOnes = allFiltered.filter(
      (candidate) =>
        !selectedCards.some(
          (selected) =>
            getUniqueId(candidate) === getUniqueId(selected)
        )
    );
    setSelectedCards([...selectedCards, ...newOnes]);
  }
};

const handleImportLinkedInCandidates = async () => {
   let Guid="";
    const guid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const email = localStorage.getItem("email")
    const roleID = localStorage.getItem("roleID")
     const jobRoleId = localStorage.getItem("jobRoleId")
    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= guid
    }


  const formattedData = selectedCards?.map((item) => ({
    userGuid: Guid,
    fullName: item.name || '',
    email: item.email || '',
    mobileNumber: item.phone || '',
    dob: "2000-01-01", // default, as not available from LinkedIn
    gender: "Male", // or null
    address: item.location,
    jobRole: jobRoleId  , // or whatever default you're using
    maritalStatus: "married",
    technicalSkill: item.skills, // optional
    experience: "", // optional
    preferLocation: selectedCountry || '',
    workMode: "Hybrid",
    profileSummery: item.profileSummary || '',
    billRate: "",
    payRate: "",
    workAuthorizationandValidity: "",
    employerName: "",
    ssn: "",
    passportNo: "",
    tworefrencesfromrecentproject: "",
    linkedInUrl: item.linkedInUrl || '',
    certifications: "",
    createdBy: email,
    countryID: selectedCountry
  }));
  console.log("formateed",formattedData)
  try {
    const response = await axios.post(
      AddBenchCandidatesProfile_BulkImport.APIURL,
      formattedData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.candidates && Array.isArray(response.data.candidates)) {
      const messages = response.data.candidates.map((candidate) => {
        const { email, statusMessage } = candidate;
     
    if (!email) {
      return `❌ <strong>Email not present</strong>, so not inserted.`;
    }

    if (statusMessage === 'Inserted') {
      return `✅ <strong>${email}</strong> added successfully.`;
    } else if (statusMessage === 'Duplicate or Already Exists') {
      return `⚠️ <strong>${email}</strong> already exists.`;
    } else {
      return `ℹ️ <strong>${email}</strong>: ${statusMessage}`;
    }
  });

      Swal.fire({
        icon: 'info',
        title: 'Candidate Upload Summary',
        html: messages.join('<br>'),
        showConfirmButton: true,
      });

      //navigate("/Employer/GetCandidatesByEmployerUserID");
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Unexpected response format.',
        text: 'Please check the server response.',
        showConfirmButton: true,
      });
    }
  } catch (error) {
    console.error("Error uploading LinkedIn candidates:", error);
    Swal.fire({
      icon: 'error',
      title: 'Upload Failed',
      text: 'An error occurred while saving LinkedIn candidates.',
    });
  }
};


const analyzejdskill = async (jobDescriptionInput, experienceInput, locationInput) => {
  const plainTextJD = stripHtml(jobDescriptionInput).toLowerCase();
  setIsLoading(true);

  try {
    // 👇 Instead of Gemini API, split the skills by comma
    const skillsArray = plainTextJD
      .split(",")
      .map((skill) => skill.trim())
      .filter(Boolean);

    await fetchLinkedInCandidates({
      jobDescription:"",
      skills: skillsArray.join(", "),
      experience: experienceInput,
      location: locationInput,
      userGuid: Guid
    });

    setExtractedJDSkills(skillsArray);

    // Store inputs as a single object
    const lastUsedInputs = {
      keyskills: jobDescriptionInput, // using original input as keyskills
      experience: experienceInput,
      location: locationInput
    };

    localStorage.setItem("lastUsedLinkedInInputs", JSON.stringify(lastUsedInputs));
  } catch (err) {
    console.error("Skill parsing failed", err);
    Swal.fire("Error", "Could not analyze key skills", "error");
  } finally {
    setIsLoading(false);
    setModalJobSkills("");
    setModalExperience("");
    setModalLocation("");
  }
};

  const getUniqueId = (card) => card.email || card.linkedInUrl || card.name;

  const handleCardClick = (clickedCard) => {
  const clickedCardID = getUniqueId(clickedCard);

  setSelectedCards((prevSelectedCards) => {
    const isCardSelected = prevSelectedCards.some((card) => getUniqueId(card) === clickedCardID);
    let updatedSelectedCards;

    if (isCardSelected) {
      updatedSelectedCards = prevSelectedCards.filter((card) => getUniqueId(card) !== clickedCardID);
    } else {
      updatedSelectedCards = [...prevSelectedCards, clickedCard];
    }

    return updatedSelectedCards;
  });
};
const handleForwardClick = () => {
  const selectedEmails = selectedCards.map(card => card.email);
  localStorage.setItem('SelectedLinkedinContactsList', JSON.stringify(selectedEmails));
  Swal.fire({
    title: "Save Candidates?",
    text: "Do you want to save the selected candidates before sending the email?",
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#00a7ac",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, Save & Proceed",
    cancelButtonText: "No, Just Send Email"
  }).then((result) => {
    if (result.isConfirmed) {
      // ✅ User wants to save — call your save function first
       handleImportLinkedInCandidates(); // you already have this
    }

 const minimalSelected = selectedCards.map(({ name, email }) => ({
  name, email
}));
  localStorage.setItem('SelectedLinkedinContacts', JSON.stringify(minimalSelected));
  localStorage.setItem('jobPlainText', jobPlainText);
  localStorage.setItem('fromSendEmailPage', 'true'); // <-- Add this flag
  localStorage.setItem('cachedCandidateData', JSON.stringify(candidateData)); // store data
  navigate(`/Employer/ViewMatchedLinkedinContacts/SelectedLinkedinContactsList`);
    });
};


useEffect(() => {
  const allFiltered = filteredCandidates.filter(
    (c) => c.email != null || c.phone != null
  );

  const allSelected = allFiltered.every((candidate) =>
    selectedCards.some(
      (selected) => getUniqueId(candidate) === getUniqueId(selected)
    )
  );

  setIsAllSelected(allSelected);
}, [filteredCandidates, selectedCards]);


  useEffect(() => {
   const slice = filteredCandidates.slice(offset, offset + perPage);

setVisibleCandidates(slice); // 👈 Store visible candidates
 setPageCount(Math.ceil(filteredCandidates.length / perPage));
    const items = viewType == 'grid' ? slice?.filter((x) => x.email != null || x.phone != null).map((data) => {
const isChecked = selectedCards.some(item => getUniqueId(item) === getUniqueId(data));

      return (
        <div className="col-sm-12 col-md-6 col-xl-6 col-lg-6 pb-3" key={data.guid}>
          <div className="card mt-2" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', maxHeight: 550, height: 550, borderRadius: 20 }}>
            <div className='card-header' style={{ background: "none", minHeight: 140 }}>
              <div className='row'>
                <div className='col-8'>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Full Name</Tooltip>)}>
                    <p className="card-title jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.name}</b></p>
                  </OverlayTrigger>
               
                </div>
              </div>
            </div>
            <div className="card-body" style={{ minHeight: 180 }}>
   {data.email != null && <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Email</Tooltip>)}>
                     <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-envelope" aria-hidden="true"></i>{data.email}</p>
                  </OverlayTrigger>}
               {data.phone != null && (
  <OverlayTrigger
    placement="bottom"
    overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Mobile Number</Tooltip>
    )}
  >
    <p style={{ fontSize: 14, display: 'flex', alignItems: 'center' }}>
      <i
        className="fas fa-phone"
        style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}
        aria-hidden="true"
      ></i>
      {data.phone}
      <a
        href={`tel:${data.phone}`}
        title="Click to Call"
        style={{ marginLeft: 10, color: "#00a7ac" }}
      >
        <i className="fas fa-phone"></i>
      </a>
    </p>
  </OverlayTrigger>
)}

                   <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Location</Tooltip>)}>
                <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-map-marker" aria-hidden="true"></i> {data.location} </p>
              </OverlayTrigger>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{data.skills}</Tooltip>)}>
                <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-map-marker" aria-hidden="true"></i> {substring_str(data.skills)} </p>
              </OverlayTrigger>
   <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{data.title}</Tooltip>)}>
                     <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-map" aria-hidden="true"></i>{substring_str(data.title)}</p>
                  </OverlayTrigger>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{data.profileSummary}</Tooltip>)}>
                <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-map-marker" aria-hidden="true"></i> {substring_str(data.profileSummary)} </p>
              </OverlayTrigger>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>LinkedinUrl</Tooltip>)}>
              <a 
            href={data.linkedInUrl?.startsWith('http') ? data.linkedInUrl : `https://${data.linkedInUrl}`} 
            target="_blank" 
            rel="noopener noreferrer"
        > <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-graduation-cap" aria-hidden="true"></i> {data.linkedInUrl}</p>
             </a> 
              </OverlayTrigger>
          
            </div>
          <div className='card-footer text-center' style={{ background: "none" }}>
                {data.email &&  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">Select to Save</Tooltip>}>
                    <input type="checkbox" checked={isChecked} onChange={() => handleCardClick(data)} />
                  </OverlayTrigger>
                 }
                </div>
          </div>
        </div>
      );
    }) :

      <div className="col-12 mt-2" style={{ overflowX: "auto", width: "100%" }}>
        <table className="table" style={{ minWidth: "100%", fontSize: 14 }}>
          <thead>
            <tr>
              <th>Full Name</th>
               <th>Email</th>
                <th>Mobile Number</th>
                 <th>Location</th>
                 <th>Technical Skills</th>
              <th>Title</th>
              <th>Profile Summary</th>
              <th>LinkedinUrl</th>
               <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {slice?.filter((x) => x.email != null || x.phone != null).map((data, index) => {
         const isChecked = selectedCards.some(item => getUniqueId(item) === getUniqueId(data));
              console.log("isChekd", isChecked)
              return (
                <tr key={index}>
                  <td>{data.name}</td>
                  <td style={{ maxWidth: 200, wordWrap: "break-word", wordBreak: "break-word", overflowWrap: "break-word" }}>{data.email}</td>
                 <td>
  {data.phone ? (
    <>
      {data.phone}
      <a
        href={`tel:${data.phone}`}
        style={{ marginLeft: 8, color: '#00a7ac' }}
        title="Click to Call"
      >
        <i className="fas fa-phone"></i>
      </a>
    </>
  ) : (
    "N/A"
  )}
</td>

                  <td>{data.location}</td>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{data.skills}</Tooltip>)}>
                  <td>{substring_str(data.skills)}</td>
                  </OverlayTrigger>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{data.title}</Tooltip>)}>
                   <td style={{ maxWidth: 250, wordWrap: "break-word", wordBreak: "break-word", overflowWrap: "break-word" }}>{substring_str(data.title)}</td>
                   </OverlayTrigger>
                   <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{data.profileSummary}</Tooltip>)}>
                   <td>{substring_str(data.profileSummary)}</td>
                   </OverlayTrigger>
               <td style={{ maxWidth: 150, wordWrap: "break-word", wordBreak: "break-word", overflowWrap: "break-word" }}>
  <a
    href={data.linkedInUrl?.startsWith('http') ? data.linkedInUrl : `https://${data.linkedInUrl}`}
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: "#00a7ac", textDecoration: "underline" }}
  >
    {data.linkedInUrl}
  </a>
</td>

                  <td>
                    <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>

          {data.email && (
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip">Select to Save</Tooltip>}
  >
    <input
      type="checkbox"
      checked={isChecked}
      onChange={() => handleCardClick(data)}
    />
  </OverlayTrigger>
)}


                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>


    setData(items);
    setPageCount(Math.ceil(filteredCandidates.length / perPage));
    
  }, [offset, searchTerm, startDate, endDate, candidateData, perPage, viewType, selectedCards]);

  return (
    <ConsultantLayout>
      <div className='container-fluid mt-3'>
 <div class="responsive-container" style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Link to="/Employer/ListofLinkedInContacts">
              <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8 }} aria-hidden="true"></i>
            </Link>
            <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>View LinkedIn Contacts</h2>
          </div>
          <div style={{ display: 'flex'}}>
             <div style={{ textAlign: 'right',marginLeft:8 }}>
               <OverlayTrigger placement="bottom" overlay={<Tooltip>Search LinkedIn Candidates</Tooltip>}>
              <button
                className="btn btn-primary mr-3"
                 onClick={() => {
    setShowLinkedinModal(true);
  }}
           style={{ backgroundColor: "#00a7ac", border: "none", borderRadius: "8px", width: "45px", height: "45px",
    display: "flex",alignItems: "center", justifyContent: "center", marginLeft: "8px"  }}
>

                <i className="fa fa-search" style={{ color: '#fff', cursor: 'pointer' }}></i>
              </button>
 </OverlayTrigger>
  </div>

     <div style={{ textAlign: 'right',marginLeft:8 }}>
               <OverlayTrigger placement="bottom" overlay={<Tooltip>Save Candidates</Tooltip>}>
              <button
                className="btn btn-primary mr-3"
       onClick={()=>  setShowImportModal(true)}
           style={{ backgroundColor: "#00a7ac", border: "none", borderRadius: "8px", width: "45px", height: "45px",
    display: "flex",alignItems: "center", justifyContent: "center", marginLeft: "8px"  }}
>

        <i className="fa fa-upload"></i>
              </button>
 </OverlayTrigger>
  </div>
<div style={{ textAlign: 'right', marginLeft: 8 }}>
  <OverlayTrigger placement="bottom" overlay={<Tooltip>Fetch Previous Results</Tooltip>}>
    <button
      className="btn btn-primary mr-3"
      onClick={handleFetchCallbackData}
      style={{
        backgroundColor: "#00a7ac",
        border: "none",
        borderRadius: "8px",
        width: "45px",
        height: "45px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginLeft: "8px"
      }}
    >
 <i className="fas fa-sync-alt"></i>

    </button>
  </OverlayTrigger>
</div>


          {showIcon === 'grid' && (
            <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
              <button
                className="btn btn-primary mr-3"
                onClick={() => handleViewToggle('list')}
                style={{ backgroundColor: "#00a7ac", border: "none", borderRadius: "8px", width: "45px", height: "45px",
    display: "flex",alignItems: "center", justifyContent: "center", marginLeft: "8px"  }}
              >
                <i className="fa fa-th-list" style={{ color: '#fff', cursor: 'pointer' }}></i>
              </button>
            </OverlayTrigger>
          )}
          
          {showIcon === 'list' && (
            <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
              <button
                className="btn btn-primary mr-3"
                onClick={() => handleViewToggle('grid')}
                 style={{ backgroundColor: "#00a7ac", border: "none", borderRadius: "8px", width: "45px", height: "45px",
    display: "flex",alignItems: "center", justifyContent: "center", marginLeft: "8px"  }}
              >
                <i className="fa fa-th" style={{ color: '#fff', cursor: 'pointer' }}></i>
              </button>
            </OverlayTrigger>
          )}
    
</div>
        </div>
        <div>

        </div>
<div className="col">
  <OverlayTrigger
    placement="bottom"
    overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Search by Skills or Location</Tooltip>
    )}
  >
    <input
      type="text"
      placeholder="Search by Skills or Location"
      className="form-control mt-3"
      id="searchcss2"
      value={searchTerm}
      onChange={handleSearch}
    />
  </OverlayTrigger>
</div>

        <hr />
     <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '20px' }}>

         <div style={{ textAlign: 'right',marginLeft:8 }}>
               <OverlayTrigger placement="bottom" overlay={<Tooltip>Select All</Tooltip>}>
             <label style={{ marginBottom: 0 }}>
    <input
      type="checkbox"
      checked={isAllSelected}
      onChange={handleSelectAll}
      style={{ marginRight: 5 }}
    />
    Select All
  </label>
 </OverlayTrigger>
  </div>
{/* 
                      {selectedCards.length > 0 && selectedCards.some(item => item.email) && (
  <div style={{ textAlign: 'right' }}>
                   <OverlayTrigger placement="bottom" overlay={<Tooltip>Send Email</Tooltip>}>

    <button className="btn btn-primary" onClick={handleForwardClick}  style={{ backgroundColor: "#00a7ac", border: "none", borderRadius: "8px", width: 'auto', height: "45px",
    display: "flex",alignItems: "center", justifyContent: "center", marginLeft: "8px"  }}>
      <i className="fa fa-arrow-right mr-1"></i> Send Email
    </button>
    </OverlayTrigger>
  </div>
)} */}
</div>
        <div className="row mt-3 pb-3">
                   {isLoading ? <center><LoadingSpinner /></center> : <>
            <div>

            </div>

            {data}
          </>}
        </div>
        {candidateData.length === 0 && (
          <div className="pb-5 text-center">
            <img title='No Data' className='no-data-img' src={nodataimg} style={{ height: 350 }} />
          </div>
        )}

        {(candidateData.length === 0) || (data?.length === 0) && (
          <div className="pb-5 text-center">
            <img title='No Data' className='no-data-img' src={nodataimg} style={{ height: 350 }} />
          </div>
        )}

              {
          candidateData.length > perPage &&
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        }
 <Modal show={showLinkedinModal} style={{ textAlign: 'center'}}  dialogClassName="custom-modal p-3"  onHide={() => setShowLinkedinModal(false)}>
                                <Modal.Header closeButton>
                                  <Modal.Title style={{color:"#00a7ac"}}>Applied Filters </Modal.Title>
                                 </Modal.Header>
                                <Modal.Body>
     

<label style={{ color: "#00a7ac", display: 'block', textAlign: 'left', marginBottom: '0.5rem' }}>
  LinkedIn URLs (comma separated)
</label>
         <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Lin URL's</Tooltip>)}>     
<textarea
 placeholder="https://linkedin.com/in/abc, https://..."
  style={{ height: 250 }}
  value={modalJobSkills}
 onChange={(e) => {
    let input = e.target.value;

    if (searchType === 'urls') {
      // Match all LinkedIn profile URLs including stuck ones
      const linkedinUrls = input.match(/https:\/\/(?:www\.)?linkedin\.com\/in\/[a-zA-Z0-9-_%]+\/?/g);

      if (linkedinUrls && linkedinUrls.length > 0) {
        input = linkedinUrls.join(', ');
      }
    }

    setModalJobSkills(input);
    setSelectedCards([]);
  }}

  className="form-control"
 />
                   </OverlayTrigger>
                   {modalSkillsError && (
  <p style={{ color: "#dc3545", fontSize: "0.9rem", textAlign: "left", marginTop: "0.25rem" }}>
    {modalSkillsError}
  </p>
)}

</Modal.Body>

                                <Modal.Footer style={{marginTop:100}}>
<Button
  variant="primary"
  onClick={() => {
    if (!modalJobSkills.trim()) {
      setModalSkillsError("This field is required");
      return;
    }
    // Save for future use
  const linkedinUrls = modalJobSkills.match(/https:\/\/(?:www\.)?linkedin\.com\/in\/[a-zA-Z0-9\-_%]+\/?/g);

    if (!linkedinUrls || linkedinUrls.length === 0) {
      setModalSkillsError("Please enter valid LinkedIn URLs");
      return;
    }

    const cleanedInput = linkedinUrls.join(', ');

    localStorage.setItem("didRunAnalyze", "true");
    console.log("1143", cleanedInput);

    analyzejdskill(cleanedInput, modalExperience, modalLocation);

    setShowLinkedinModal(false);
  }}
>
  Click to Proceed
</Button>




                                  <Button variant="secondary"  onClick={() => setShowLinkedinModal(false)}>Cancel</Button>
                        
                                </Modal.Footer>
                              </Modal>
         <Modal show={showImportModal} onHide={() => setShowImportModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Save Candidates To</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{marginLeft:10}}>
    <Form.Check
      type="radio"
      label="Candidate Pool"
      name="importDestination"
      value="candidatePool"
      checked={selectedDestination === "candidatePool"}
      onChange={(e) => setSelectedDestination(e.target.value)}
    />
    <Form.Check
      type="radio"
      label="Staffing - Recruiter"
      name="importDestination"
      value="recruiter"
      checked={selectedDestination === "recruiter"}
      onChange={(e) => setSelectedDestination(e.target.value)}
    />
    <Form.Check
      type="radio"
      label="Staffing - Bench Sales"
      name="importDestination"
      value="benchSales"
      checked={selectedDestination === "benchSales"}
      onChange={(e) => setSelectedDestination(e.target.value)}
    />
    <Form.Check
      type="radio"
      label="Leads"
      name="importDestination"
      value="leads"
      checked={selectedDestination === "leads"}
      onChange={(e) => setSelectedDestination(e.target.value)}
    />
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowImportModal(false)}>
      Cancel
    </Button>
    <Button variant="primary" onClick={handleSaveFetchedCandidates}>
      Save
    </Button>
  </Modal.Footer>
</Modal>


      </div>
    </ConsultantLayout>
  );
}

export default ViewMatchedLinkedinContacts;

